import { FC, PropsWithChildren, useMemo } from 'react';
import { ThemeProvider, createTheme } from '@mui/material';

import { FullscreenLayout } from '@shared/components/layouts/FullscreenLayout';
import { useTheme } from '@mui/material';


export const SignUpLayout: FC<PropsWithChildren> = ({ children }) => {
  const innerTheme = useInnerTheme();

  return (
    <FullscreenLayout
      sx={{
        overflowY: 'auto',
        backgroundImage: 'linear-gradient(135deg, rgb(0, 67, 92), rgb(6, 42, 55))',
      }}
    >
      <ThemeProvider theme={innerTheme}>
        {children}
      </ThemeProvider>
    </FullscreenLayout>
  );
};

const useInnerTheme = () => {
  const theme = useTheme();

  return useMemo(() => createTheme(({
    ...theme,
    palette: {
      ...theme.palette,
      text: {
        ...theme.palette.text,
        primary: '#ffffff80',
      },
    },
    components: {
      ...theme.components,
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            color: '#FFFFFF',
            backgroundColor: '#ffffff1a',
            borderRadius: '8px',
            '& fieldset.MuiOutlinedInput-notchedOutline': {
              borderColor: '#fff3',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.primaryAlt.main,
            },
          },
          input: {
            '&:-webkit-autofill': {
              WebkitBoxShadow: '0 0 0 100px transparent inset',
              WebkitTextFillColor: '#FFFFFF',
              transition: 'background-color 5000s ease-in-out 0s',
            },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: '#fffc',
            '&.Mui-focused': {
              color: '#fffc',
            },
          },
        },
      },
      MuiDivider: {
        styleOverrides: {
          root: {
            '&::before, &::after': {
              borderColor: '#fff3',
            },
          },
          wrapper: {
            color: '#ffffff80',
          },
        },
      },
    },
  })), [theme]);
};